import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import NearMeIcon from '@mui/icons-material/NearMe';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';

const item: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
        <Box
          component="img"
          src="/static/themes/onepirate/productCurvyLines.png"
          alt="curvy lines"
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={0} direction="column" justifyContent="space-between" alignItems="center">
          <Grid container spacing={3}>
            <Box sx={{ flex: 2 }} textAlign='center'>
              <Typography variant="h1" align="center" sx={{ my: 5, fontSize: 30 }}>
                本サイトが対象とする読者の想定 <br /> <br />
              </Typography>
            </Box>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <NotificationImportantIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  ビジネスプロフェッショナル
                </Typography>
                <Typography variant="h5">
                  コンテンツはさておき、このサイトで説明するお作法をすべて実践すれば、大手企業におけるセクションマネージャ（部下50人程度の管理職）くらいは務まる想定です。<br />
                  マネジメントコミュニケーションに耐えうるプレゼン資料のフォーマットとして最低限知っていないといけない内容は90％網羅しているはずです。そういう意味でプレゼン初級から中級レベルを対象としています。
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <TaskAltIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  部下を持つマネージャー
                </Typography>
                <Typography variant="h5">
                  外資系戦略コンサルの新卒や中途の1年目では、会社が用意するトレーニングを通じて徹底的にプレゼンスキル（お作法）を叩き込まれます。
                  一方で、（マネージャ自身のプレゼンスキルがすでに高くても）体系的なプレゼンスキルがトレーニング（資料）として存在していない企業も数多くあるでしょう。 <br />
                  そんな際、「マストスキル」として部下（新卒含む）にわたすトレーニング資料として、「これ、読んでおいて」と渡してもらえれば幸いです。
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <NearMeIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  つまり、メッセージを届けたい人
                </Typography>
                <Typography variant="h5">
                  良いプレゼンとは、伝えるべきメッセージが伝わるプレゼンです。そのメッセージはシンプルである必要がありますし、そのメッセージの背景にある（複雑な）ロジックを構造的かつ平易に説明している必要もあります。<br />
                  そのスキルは、究極的には、ビジネスプロフェッショナルであっても、研究者やエンジニアであっても、メッセージを伝える際のスキルとして汎用的に求められるはずです。
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box >
  );
}

export default ProductValues;
